<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 360px">Quantidade de profissional por tipo</legend>
      <div class="row" style="margin-top: 15px">
        <div class="title-group">Tipo de profissional</div>
        <div class="group-itens">
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="MILITAR" id="MILITAR" v-model="form.tipos" @click="desativaTodos" />
            <label class="form-check-label" for="MILITAR"> Militar </label>
          </div>
          <div class="item-filter">
            <input class="form-check-input" type="checkbox" value="TERCEIRIZADO" id="TERCEIRIZADO" v-model="form.tipos" @click="desativaTodos" />
            <label class="form-check-label" for="TERCEIRIZADO"> Terceirizado </label>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="searchData">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 380px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="dadosTabela.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 170px">
            <a-tooltip title="Imprimir" placement="top" v-if="dadosTabela.length > 0" @click="encaminharEmail">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-share" style="margin: 0px 10px"></i>
                  <span>Encaminhar</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>

        <div class="row" style="margin-top: 10px">
          <a-table :dataSource="dadosTabela" :columns="columns"> </a-table>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { abrirImpressaoPorBlob, encaminharEmailTo } from '@/utils/servicos-utils';
import { gerarRelatorioHtml, gerarRelatorioPdf } from '@/components/service/gerarRelatorio';
import { getQtdProfissionalPorTipo } from '@/components/service/profissionalService';

export default {
  name: 'ProfTipoRelatorio',
  data() {
    return {
      listaTipoProfissional: ['MILITAR', 'TERCEIRIZADO'],
      dadosTabela: [],
      form: {
        tipos: [],
      },
      columns: [
        {
          title: 'Tipo Profissional',
          dataIndex: 'descricao',
          key: 'descricao',
        },
        {
          title: 'Quantidade',
          dataIndex: 'quantidade',
          key: 'quantidade',
        },
      ],
    };
  },

  methods: {
    async searchData() {
      await getQtdProfissionalPorTipo(this.form)
        .then((r) => {
          this.dadosTabela = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async imprimirPDF() {
      if (this.dadosTabela.length > 0) {
        await gerarRelatorioPdf({
          listaDadosDocumento: this.dadosTabela,
          nomeDocumentoHtml: 'relatorio-profissional-qtde-por-tipo.html',
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async encaminharEmail() {
      if (this.dadosTabela.length > 0) {
        await gerarRelatorioHtml({
          listaDadosDocumento: this.dataConvenioPaciente,
          nomeDocumentoHtml: 'relatorio-convenio-paciente.html',
        }).then((r) => {
          encaminharEmailTo('Relatório de Paciente por Convenio', r.data);
        });
      }
    },
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
